import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-cy": "GeneralLedgerAlert_Tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_tooltip, { location: "bottom" }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn_icon, _mergeProps({ class: "align-end" }, props, {
          onClick: _ctx.openCloseDialog,
          "data-cy": "GeneralLedgerAlert_Click"
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_badge, {
              color: "red",
              content: 1,
              "data-cy": "GeneralLedgerAlert_Badge"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "pb-1",
                  color: "primary",
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" $oss-warning ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1040, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.tooltipMessage), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.isVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
      "hide-valid": true,
      title: _ctx.dialogTitle
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "pa-5 ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              headers: _ctx.headers,
              items: _ctx.check.accountingPeriodBalanceDiagnostics,
              "items-per-page": -1,
              class: "table mt-2",
              "fixed-header": "",
              "hide-default-footer": "",
              dense: ""
            }, {
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(props.item.accountingPeriod.start)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(props.item.accountingPeriod.end)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.check?.balanceDifference)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                    props.item.carryForwardCheck?.balanceDifference,
                                )), 1),
                  _createElementVNode("td", null, _toDisplayString(props.item.documentNotBalancedChecks?.length || "-"), 1)
                ])
              ]),
              _: 1
            }, 8, ["headers", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}